import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faCar,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import './santafe.css';
import showroom from "../../images/showroom/santafe.png"
/**** Fotos Banner ****/
import Slider1 from "../../images/modelos/nuevosantafe/banner/santafe-banner-1.webp";
import Slider2 from "../../images/modelos/nuevosantafe/banner/santafe-banner-2.webp";
import Slider3 from "../../images/modelos/nuevosantafe/banner/santafe-banner-3.webp";
import Slider4 from "../../images/modelos/nuevosantafe/banner/santafe-banner-4.webp";
import Slider5 from "../../images/modelos/nuevosantafe/banner/santafe-banner-5.webp";
/****Fotos calidad de tiempo ****/
import Calidad1 from "../../images/modelos/nuevosantafe/calidad/calidad1.webp";
import Calidad2 from "../../images/modelos/nuevosantafe/calidad/calidad2.webp";
import Calidad3 from "../../images/modelos/nuevosantafe/calidad/calidad3.webp";
import Galeria2 from "../../images/modelos/nuevosantafe/galeria/galeria2.webp";
import Galeria3 from "../../images/modelos/nuevosantafe/galeria/galeria3.webp";
import Galeria4 from "../../images/modelos/nuevosantafe/galeria/galeria4.webp";
import Galeria5 from "../../images/modelos/nuevosantafe/galeria/galeria5.webp";
import Galeria6 from "../../images/modelos/nuevosantafe/galeria/galeria6.webp";
import Galeria7 from "../../images/modelos/nuevosantafe/galeria/galeria7.webp";
import Galeria8 from "../../images/modelos/nuevosantafe/galeria/galeria8.webp";
import Exterior from "../../images/modelos/nuevosantafe/disenio/exterior.webp";
import Disenio1 from "../../images/modelos/nuevosantafe/disenio/disenio1.webp";
import Disenio2 from "../../images/modelos/nuevosantafe/disenio/disenio2.webp";
import Disenio3 from "../../images/modelos/nuevosantafe/disenio/disenio3.webp";
import Disenio4 from "../../images/modelos/nuevosantafe/disenio/disenio4.webp";
import Disenio5 from "../../images/modelos/nuevosantafe/disenio/disenio5.webp";
import Disenio6 from "../../images/modelos/nuevosantafe/disenio/disenio6.webp";
import Disenio7 from "../../images/modelos/nuevosantafe/disenio/disenio7.webp";
/****Fotos rendimiento ****/
import Rendimiento1 from "../../images/modelos/nuevosantafe/rendimiento/rendimiento1.webp";
import Rendimiento2 from "../../images/modelos/nuevosantafe/rendimiento/rendimiento2.webp";
import Rendimiento3 from "../../images/modelos/nuevosantafe/rendimiento/rendimiento3.webp";
import Rendimiento4 from "../../images/modelos/nuevosantafe/rendimiento/rendimiento4.webp";
import Rendimiento5 from "../../images/modelos/nuevosantafe/rendimiento/rendimiento5.webp";
import Rendimiento6 from "../../images/modelos/nuevosantafe/rendimiento/rendimiento6.webp";
/****Fotos seguridad ****/
import Seguridad1 from "../../images/modelos/nuevosantafe/seguridad/seguridad1.webp";
import Seguridad2 from "../../images/modelos/nuevosantafe/seguridad/seguridad2.webp";
import Seguridad3 from "../../images/modelos/nuevosantafe/seguridad/seguridad3.webp";
import Seguridad4 from "../../images/modelos/nuevosantafe/seguridad/seguridad4.webp";
import Seguridad5 from "../../images/modelos/nuevosantafe/seguridad/seguridad5.webp";
import Seguridad6 from "../../images/modelos/nuevosantafe/seguridad/seguridad6.webp";
/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/nuevosantafe/conveniencia/conveniencia1.webp";
import Conveniencia2 from "../../images/modelos/nuevosantafe/conveniencia/conveniencia2.webp";
import Conveniencia3 from "../../images/modelos/nuevosantafe/conveniencia/conveniencia3.webp";
import Conveniencia4 from "../../images/modelos/nuevosantafe/conveniencia/conveniencia4.webp";
import Conveniencia5 from "../../images/modelos/nuevosantafe/conveniencia/conveniencia5.webp";
import Conveniencia6 from "../../images/modelos/nuevosantafe/conveniencia/conveniencia6.webp";
/****Ficha técnica ****/
import SantaFeCatalogo from "../../fichas/nuevo-santafe-brochure.pdf";;

function InfoSantaFe() {
  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    loop: true,
    loopedSlides: 5, //looped slides should be the same
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    slidesPerView: 5,
    loop: true,
    freeMode: true,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    centeredSlides: true,
  };

  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  const onChangeMenu = (menu) => {
    switch (menu) {
      case "calidad":
        document.getElementById("tab-calidad").className = "color-hover";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-block";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider1;
        break;
      case "disenio":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-hover";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-block";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider2;
        break;
      case "rendimiento":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-hover";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-block";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider3;
        break;
      case "seguridad":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-hover";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-block";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider4;
        break;
      case "conveniencia":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-hover";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-block";
        document.getElementById("img-carrusel").src = Slider5;
        break;
      default:
        break;
    }
  };
  return (
    <Fragment>
      <link rel="preload" as="image" href={Slider1} />
      <Container fluid={true}>
        <Row>
          <Col md={12} className="px-0">
            <div>
              <picture>
                <Image
                  src={Slider1}
                  fluid
                  alt="Santa Fe Banner"
                  className="banner"
                  id="img-carrusel"
                />
              </picture>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="menu-vehiculo sticky-top">
        <Container>
          <Row className="py-2 py-md-4">
            <Col xs={2} md={2} className="my-auto d-none d-sm-block">
              <h1 className="menu-modelo">SANTA FE HYBRID</h1>
            </Col>
            <Col
              xs={12}
              md={6}
              className="my-auto vehiculo-item text-md-center px-0"
            >
              <ul className="my-auto p-0 m-0">
                <li
                  id="tab-calidad"
                  onClick={() => onChangeMenu("calidad")}
                  className="color-hover"
                >
                  Calidad de tiempo
                </li>
                <li
                  id="tab-disenio"
                  onClick={() => onChangeMenu("disenio")}
                  className="color-normal"
                >
                  Diseño
                </li>
                <li
                  id="tab-rendimiento"
                  onClick={() => onChangeMenu("rendimiento")}
                  className="color-normal"
                >
                  Rendimiento
                </li>
                <li
                  id="tab-seguridad"
                  onClick={() => onChangeMenu("seguridad")}
                  className="color-normal"
                >
                  Seguridad
                </li>
                <li
                  id="tab-conveniencia"
                  onClick={() => onChangeMenu("conveniencia")}
                  className="color-normal"
                >
                  Conveniencia
                </li>
              </ul>
            </Col>
            <Col xs={3} md={1} className="text-center my-auto cont-extra">
              <a
                href="static/media/nuevo-santafe-ficha-tecnica.645584f0.pdf"
                className="text-reset text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faDownload} />
                <span className="menu-extra"> Ficha</span>
              </a>
            </Col>
            <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
              <a
                href={SantaFeCatalogo}
                className="text-reset text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faDownload} />
                <span className="menu-extra"> Catálogo</span>
              </a>
            </Col>
            <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
              <Link
                to="/cotizador/nuevosantafe"
                className="text-reset text-decoration-none"
              >
                <FontAwesomeIcon icon={faCar} />
                <span className="menu-extra">Cotizar</span>
              </Link>
            </Col>
            <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
              <Link
                to="/test-drive/nuevosantafe"
                className="text-reset text-decoration-none"
              >
                <FontAwesomeIcon icon={faCar} />
                <span className="menu-extra">Test Drive</span>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
      {/***************************************** calidad ***************************************/}
      <section id="calidad">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">Santa Fe Hybrid</h2>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Llegó el Nuevo Santa Fe Hybrid y no tienen nada que demostrar, con él,
                transforma el trayecto en un momento auténtico. Cabina tipo lounge para 7 pasajeros,
                cuero NAPPA, sunroof panorámico y climatización tri-zona, todo está pensado para que
                el confort no se note, se sienta.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="bg-black py-2 px-2 py-md-4 px-md-0">
              <Image src={Calidad1} alt="Santa Fe Calidad" className="img-fluid1" fluid />
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col md={6} className="my-auto order-2 order-md-1">
                <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                  Presencia que impone
                </h3>
                <p className="specs-text px-3 px-md-0">
                  Sus proporciones y las luces frontales en forma de H hacen que destaque sin esfuerzo.
                </p>
              </Col>
              <Col md={6} className="my-auto order-1 order-md-2">
                <Image src={Calidad2} alt="Santa Fe Rendimiento" className="img-fluid2" fluid />
              </Col>
            </Row>
            <Row className="py-3 py-md-5">
              <Col md={6} className="my-auto">
                <Image src={Calidad3} alt="Santa Fe Poderoso" className="img-fluid2" fluid />
              </Col>
              <Col md={6} className="my-auto">
                <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                  Amplio espacio interior
                </h3>
                <p className="specs-text px-3 px-md-0">
                  Tres filas, múltiples configuraciones y un diseño que no impone rutina.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <Container>
          <Row className="py-3 py-md-5">
            <Col md={12} className="text-center">
              <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
              <div>
                <Swiper {...gallerySwiperParams}>
                  <div>
                    <Image
                      src={Galeria2}
                      fluid
                      alt="Santa Fe Slider 2"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria3}
                      fluid
                      alt="Santa Fe Slider 3"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria4}
                      fluid
                      alt="Santa Fe Slider 4"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria5}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria6}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria7}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria8}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria1"
                    />
                  </div>
                </Swiper>
                <Swiper {...thumbnailSwiperParams}>
                  <div>
                    <Image
                      src={Galeria2}
                      fluid
                      alt="Santa Fe Slider 2"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria3}
                      fluid
                      alt="Santa Fe Slider 3"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria4}
                      fluid
                      alt="Santa Fe Slider 4"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria5}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria6}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria7}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria8}
                      fluid
                      alt="Santa Fe Slider 5"
                      className="galeria2"
                    />
                  </div>
                </Swiper>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-right">
              <p className="specs-text texto-img px-3 px-md-0">
                *Imágenes referenciales, con fines de uso publicitario.
              </p>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6}></Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("disenio")}
                  className="titulo-navegacion"
                >
                  Diseño
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** disenio ***************************************/}
      <section id="disenio" className="d-none">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title mb-0">Nada que demostrar</h2>
              <p className="model-text mt-3 px-3 px-md-0">
                En un mundo donde todos intentan llamar la atención, nosotros preferimos que las acciones hablen.
                Porque la verdadera confianza no se grita, se respira en cada detalle: En nuestro diseño,
                en cada asiento y en cada viaje.
              </p>
              <p className="model-text mt-3 px-3 px-md-0">
                No venimos a convencerte. Porque el Nuevo Santa Fe está hecho como nunca antes.
              </p>
              <p className="model-text mt-3 px-3 px-md-0">
                Mientras otros te tienen que mostrar todo, nosotros no tenemos nada que demostrar.
              </p>
            </Col>
          </Row>
        </Container>
        <Container style={{ minHeight: '300px' }} className="cotizador pb-5">
          <a href="https://my.matterport.com/show/?m=Szi8YWWecju" target="_blank" rel="noopener noreferrer">
            <center>
              <Image src={showroom} alt="Showroom Virtual Santa Fe" fluid width={700} height={350} />
            </center>
          </a>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="pt-3 pt-md-5">
              <Col md={12} className="text-center">
                <h2 className="model-title mb-0">Diseño que no necesita presentación</h2>
                <p className="specs-text mt-3 px-3 px-md-0">
                  Otros buscan impresionar con formas. SANTA FE impresiona con presencia.
                  Con un diseño bold que se siente robusto y elegante desde todos los ángulos,
                  este SUV no pide atención: todos los ojos voltean a verlo. Sus líneas firmes,
                  luces en forma de H y su silueta extendida no gritan lujo, lo viven.
                </p>
                <p className="specs-text pb-md-4 px-3 px-md-0">
                  Porque cuando el diseño habla, no hay nada que demostrar.
                </p>
              </Col>
            </Row>
            <Row className="pb-3 pb-md-2 mt-4">
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Disenio1} alt="Santa Fe tablero" fluid />
                <h3 className="specs-text mt-3 px-3 px-md-0">
                  Llantas de aleación de 20 pulgadas / Guardafangos perfilados
                </h3>
              </Col>
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Disenio2} alt="Santa Fe Pantalla" fluid />
                <h3 className="specs-text mt-3 px-3 px-md-0">
                  Faros delanteros con luces en forma de H (tipo LED / proyección)
                </h3>
              </Col>
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Disenio3} alt="Santa Fe Luces" fluid />
                <h3 className="specs-text mt-3 px-3 px-md-0">
                  Sunroof panorámico con función “One Touch Safety”
                </h3>
              </Col>
            </Row>
            <Row className="pb-3 pb-md-2 mt-4">
              <Image src={Disenio7} alt="Santa Fe tablero" fluid />
            </Row>
          </Container>
        </div>
        <Container>
          <Row className="pt-3 pt-md-5">
            <Col md={12} className="text-center">
              <h2 className="model-title mb-0">Mientras otros te venden futuro, aquí lo vives</h2>
              <p className="specs-text mt-3 px-3 px-md-0">
                El interior de el nuevo SANTA FE no necesita adornarse. Espacios amplios, materiales que se sienten bien,
                pantallas curvas y soluciones pensadas para vivir más cómodo, sin esfuerzo.
                Es ese tipo de elegancia silenciosa que se nota apenas entras.
              </p>
              <p className="specs-text pb-md-4 px-3 px-md-0">
                Y que no tiene nada que demostrar.
              </p>
            </Col>
          </Row>
          <Row className="pb-3 pb-md-4">
            <Col md={4} className="mt-3 mt-md-4">
              <Image src={Disenio4} alt="Santa Fe tablero" fluid />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Pantalla curva panorámica de 12.3” + 12.3”
              </h3>
            </Col>
            <Col md={4} className="mt-3 mt-md-4">
              <Image src={Disenio5} alt="Santa Fe Pantalla" fluid />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Guantera con lámpara UV-C
              </h3>
            </Col>
            <Col md={4} className="mt-3 mt-md-4">
              <Image src={Disenio6} alt="Santa Fe Luces" fluid />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Asientos de cuero NAPPA color camel
              </h3>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-right">
              <p className="specs-text texto-img px-3 px-md-0">
                *Imágenes referenciales, con fines de uso publicitario.
              </p>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("calidad")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Calidad de tiempo
                </span>
              </Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("rendimiento")}
                  className="titulo-navegacion"
                >
                  Rendimiento
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** rendimiento ***************************************/}
      <section id="rendimiento" className="d-none">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">
                Eficiencia y potencia
              </h2>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Potente cuando lo necesitas. Eficiente siempre.
              </p>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                El nuevo SANTA FE responde con firmeza en cualquier camino, sin sacrificar consumo ni suavidad.
              </p>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Su sistema híbrido trabaja por ti, sin exigirte cambios.
              </p>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Porque cuando todo está bien pensado, no hay nada que demostrar.
              </p>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center mt-3 pb-3 pb-md-4">
            <Col md={3} className="mt-4 mt-md-4">
              <Image src={Rendimiento1} alt="Santa Fe Motor" fluid />
              <h3 className="specs-text mt-3">Motor híbrido 1.6 T-GDI</h3>
            </Col>
            <Col md={3} className="mt-4 mt-md-4">
              <Image src={Rendimiento2} alt="Santa Fe transmision" fluid />
              <h3 className="specs-text mt-3">e-Comfort Drive</h3>
            </Col>
            <Col md={3} className="mt-4 mt-md-4">
              <Image src={Rendimiento3} alt="Santa Fe transmision" fluid />
              <h3 className="specs-text mt-3">e-Dynamic Drive</h3>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center mt-3 pb-3 pb-md-4">
            <Col md={4} className="mt-4 mt-md-4">
              <Image src={Rendimiento4} alt="Santa Fe Motor" fluid />
              <h3 className="specs-text mt-3">Modo de manejo / Modo de terreno</h3>
              <h3 className="specs-text mt-3">(Auto, Barro, Arena, Nieve)</h3>
            </Col>
            <Col md={4} className="mt-4 mt-md-4">
              <Image src={Rendimiento5} alt="Santa Fe transmision" fluid />
              <h3 className="specs-text mt-3">Paddle Shift (Paletas de cambio)</h3>
              <h3 className="specs-text mt-3">Modelo de frenado regenerativo</h3>
            </Col>
          </Row>
          <Row className="mt-4 mt-md-5">
            <Col md={12}>
              <Image
                src={Rendimiento6}
                alt="Santa Fe Banner"
                className="w-100"
                fluid
              />
            </Col>
          </Row>
          <Row className="py-4">
            <Col md={12} className="text-right">
              <p className="specs-text texto-img px-3 px-md-0">
                *Imágenes referenciales, con fines de uso publicitario.
              </p>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("disenio")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Diseño
                </span>
              </Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("seguridad")}
                  className="titulo-navegacion"
                >
                  Seguridad
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** seguridad ***************************************/}
      <section id="seguridad" className="d-none">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">
                Seguridad sin complicaciones
              </h2>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Con visión periférica, asistencia en cada maniobra y sistemas que responden antes que tú,
                te protege sin interrumpirte. Todo está cubierto. Todo está pensado. Porque la seguridad
                real no se siente forzada. Se nota.
              </p>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Y no necesita demostrarse.
              </p>
            </Col>
          </Row>
          <Row className="mt-md-5 mt-3 d-flex justify-content-center">
            <Col md={4} className="mt-4">
              <Image src={Seguridad1} alt="Santa Fe Cinturones" fluid />
              <h3 className="specs-subtitle-bold mt-3">
                Asistente de puntos ciegos (BVM)
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Seguridad2} alt="Sonata Carroceria" fluid />
              <h3 className="specs-subtitle-bold mt-3">
                Hyundai Smart Sense
              </h3>
              <h3 className="specs-subtitle-bold mt-3">
                Prevención de colisión frontal (FCA)
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Seguridad3} alt="Santa Fe Cinturones" fluid />
              <h3 className="specs-subtitle-bold mt-3">
                Asistente de prevención de colisión en
              </h3>
              <h3 className="specs-subtitle-bold mt-3">
                estacionamiento (PCA)
              </h3>
            </Col>
          </Row>
          <Row className="mt-md-4 d-flex justify-content-center">
            <Col md={4} className="mt-4">
              <Image src={Seguridad4} alt="Santa Fe Cinturones" fluid />
              <h3 className="specs-subtitle-bold mt-3">
                Monitor de vista periférica (SVM)
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Seguridad5} alt="Sonata Carroceria" fluid />
              <h3 className="specs-subtitle-bold mt-3">
                Alerta de ocupantes traseros (ROA)
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Seguridad6} alt="Sonata Carroceria" fluid />
              <h3 className="specs-subtitle-bold mt-3">
                Control de crucero inteligente (SCC)
              </h3>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-right">
              <p className="specs-text texto-img px-3 px-md-0">
                *Imágenes referenciales, con fines de uso publicitario.
              </p>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("rendimiento")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Rendimiento
                </span>
              </Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("conveniencia")}
                  className="titulo-navegacion"
                >
                  Conveniencia
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** conveniencia ***************************************/}
      <section id="conveniencia" className="d-none">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">
                Totalmente conectado
              </h2>
              <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                El nuevo SANTA FE integra carga inalámbrica, puertos USB-C en cada fila,
                y una doble pantalla curva de 12.3” con Apple CarPlay y Android Auto.
                Tecnología útil, conexión inmediata y comodidad que se nota.
              </p>
              <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                Porque cuando está bien hecho, no hay nada que demostrar.
              </p>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className="py-3 py-md-5">
            <Col md={4} className="mt-4">
              <Image
                src={Conveniencia1}
                alt="Santa Fe mandos integrados volante"
                fluid
              />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Puerta trasera eléctrica inteligente
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image
                src={Conveniencia2}
                alt="Santa Fe botón encendido"
                fluid
              />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Asientos con ventilación / calefacción
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Conveniencia3} alt="Santa Fe ducto ventilación" fluid />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Control de temperatura bi-zona
              </h3>
            </Col>
          </Row>
          <Row className="py-3 py-md-5">
            <Col md={4} className="mt-4">
              <Image
                src={Conveniencia4}
                alt="Santa Fe mandos integrados volante"
                fluid
              />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Cargador inalámbrico de celular
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image
                src={Conveniencia5}
                alt="Santa Fe botón encendido"
                fluid
              />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                2ª fila plegable y abatible
              </h3>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Conveniencia6} alt="Santa Fe ducto ventilación" fluid />
              <h3 className="specs-text mt-3 px-3 px-md-0">
                Ventanas con función “One Touch”
              </h3>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-right">
              <p className="specs-text texto-img px-3 px-md-0">
                *Imágenes referenciales, con fines de uso publicitario.
              </p>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("seguridad")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Seguridad
                </span>
              </Col>
              <Col xs={6} md={6}></Col>
            </Row>
          </Container>
        </div>
      </section>
    </Fragment>
  );
}
export default InfoSantaFe;